import { useDarkMode } from "../ThemeContext";
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import "../styles/Pages.css";
import "../styles/Vachanamrut.css";

const API_URL =
  "https://withered-sound-8cec.akshar369.workers.dev/?endpoint=hariprasangam";

const CATEGORIES = [
  {
    id: 15,
    en: "P.P. PrabodhjivanSwamiji Jivandarshan",
    gu: "પ.પૂ. પ્રબોધજીવનસ્વામીજી જીવનદર્શન",
  },
  { id: 16, en: "Adhyatmik Suj", gu: "અધ્યાત્મિક સૂઝ" },
  { id: 17, en: "Divya Anubhav", gu: "દિવ્ય અનુભવ" },
  { id: 18, en: "Divya Darshan", gu: "દિવ્ય દર્શન" },
  { id: 19, en: "Raksha", gu: "રક્ષા" },
  { id: 20, en: "Ashirvad", gu: "આશીર્વાદ" },
  { id: 21, en: "Swaroopnishtha", gu: "સ્વરૂપનિષ્ઠા" },
  { id: 22, en: "Prabhu Bhakti", gu: "પ્રભુ ભક્તિ" },
  { id: 23, en: "Akshar Sparsh", gu: "અક્ષર સ્પર્શ" },
  { id: 24, en: "Dasatva", gu: "દાસત્વ" },
  { id: 25, en: "Yuva Pravruti", gu: "યુવા પ્રવૃતિ" },
  { id: 26, en: "Bal Pravruti", gu: "બાળ પ્રવૃતિ" },
  { id: 27, en: "Guru Bhakti", gu: "ગુરુભક્તિ" },
  { id: 28, en: "Bhaktoni Bhakti", gu: "ભક્તોની ભક્તિ" },
  { id: 29, en: "Seva", gu: "સેવા" },
  { id: 30, en: "Swami Sevak Bhav", gu: "સ્વામી સેવક ભાવ" },
  { id: 31, en: "Swamini Vato", gu: "સ્વામીની વાતો" },
  { id: 32, en: "Suhradbhav", gu: "સુહૃદભાવ" },
  { id: 33, en: "Sambandhno Mahima", gu: "સંબંધનો મહિમા" },
  { id: 34, en: "Bhajan", gu: "ભજન" },
  { id: 35, en: "Sabha", gu: "સભા" },
  { id: 36, en: "Kathavarta", gu: "કથાવાર્તા" },
  { id: 37, en: "Ambrish", gu: "અંબરીષ" },
  { id: 38, en: "Swadharm", gu: "સ્વધર્મ" },
  { id: 39, en: "Saralata", gu: "સરળતા" },
  { id: 40, en: "Nirdoshbuddhi", gu: "નિર્દોષબુદ્ધિ" },
  { id: 41, en: "Aksharbrahm", gu: "અક્ષરબ્રહ્મ" },
  { id: 42, en: "Upasana", gu: "ઉપાસના" },
  { id: 43, en: "Antaryami", gu: "અંતર્યામી" },
  { id: 44, en: "Olakhan", gu: "ઓળખાણ" },
  { id: 45, en: "Pragatya Harinu", gu: "પ્રાગટ્ય હરિનુ" },
  { id: 46, en: "Abhyas", gu: "અભ્યાસ" },
  { id: 47, en: "Agya Palan", gu: "આજ્ઞા પાલન" },
  { id: 48, en: "Vishvas", gu: "વિશ્વાસ" },
  { id: 49, en: "Prarthana", gu: "પ્રાર્થના" },
  { id: 50, en: "Smruti", gu: "સ્મૃતિ" },
  { id: 51, en: "Mahima", gu: "મહિમા" },
  { id: 52, en: "Nishtha", gu: "નિષ્ઠા" },
  { id: 53, en: "Bhagavadi", gu: "ભગવદી" },
  { id: 54, en: "Nimit", gu: "નિમિત" },
];

const TAGS = [
  "We Are One",
  "diversion",
  "sincere",
  "social media",
  "અંતદ્રષ્ટિ",
  "અંતર્યામી",
  "અંતિમ કક્ષાનું લેશન",
  "અંતિમ નિશાન",
  "અંતિમ સાધના",
  "અંબરિશ",
  "અંબરીશ",
  "અંબરીષ",
  "અક્ષર",
  "અક્ષર સુઝ",
  "અક્ષર સૂઝ",
  "અક્ષર સ્પર્શ",
  "અધિકાર",
  "અનંતગણું",
  "અનાજ",
  "અનિર્દેશ",
  "અનુભવ",
  "અનુસંધાન",
  "અન્નકૂટ",
  "અપમાન",
  "અપેક્ષા",
  "અભાવ",
  "અભ્યાસ",
  "અસ્તિત્વ",
  "અસ્તિત્વ રહિત",
  "અસ્મિતા",
  "અહંકાર",
  "આંખ",
  "આત્મા",
  "આત્માવિશ્વાસ",
  "આત્મીય સ્પર્શ",
  "આત્મીયતા",
  "આરતી",
  "આશિષ",
  "આશીર્વાદ",
  "ઉત્સવ",
  "એક રહેણીકરણી",
  "એકાદશી",
  "એક્સરસાઈઝ",
  "એમ્પ્લોયી",
  "એવીએમ",
  "ઐશ્વર્ય",
  "કટાક્ષ",
  "કથાવાર્તા",
  "કથાવાર્તા આત્માનો પ્રાણ છે",
  "કથાવાર્તા નો ઇશક",
  "કર્તાહર્તા",
  "કાંદીવલી",
  "કાર્યકર્તા માટે",
  "કીર્તન",
  "કૃતજ્ઞતા",
  "કેનેડા",
  "કોલ",
  "ક્રોધ",
  "ખરેખરા સાધુ",
  "ખીજો",
  "ગઢડા અંત્ય ૭",
  "ગઢડા પ્રથમ ૨૭",
  "ગઢડા પ્રથમ ૭૬",
  "ગઢડા મધ્ય ૧૩",
  "ગઢડા મધ્ય ૨૮",
  "ગણિકા",
  "ગણિત",
  "ગરજ",
  "ગાર્ડન",
  "ગુજરાતી",
  "ગુણ ગાવા",
  "ગુણ દર્શન",
  "ગુણગ્રહણ",
  "ગુણાતીત",
  "ગુણાતીત ભક્તિ",
  "ગુણાતીતાનંદ સ્વામી",
  "ગુરુભક્તિ",
  "ચરણસ્પર્શ",
  "ચિંતા",
  "ચિકનપોક્સ",
  "ચીડિયો સ્વભાવ",
  "છત્રી",
  "છૂપા રહેવું",
  "છોડ",
  "જતન",
  "જનની",
  "જાણપણું",
  "જીવનદર્શન",
  "જોડની સેવા",
  "જોડે છો મહારાજ",
  "ઝૂકવું",
  "ઝોળી",
  "ટેકો",
  "ટેન્શન",
  "ઠાકોરજી",
  "ડાયમંડ",
  "ડાયવર્ઝન",
  "ડેકોરેશન",
  "તળાવ",
  "તાવ",
  "થાળ",
  "દંડવત",
  "દંડવત્",
  "દક્ષા",
  "દયા",
  "દર્શન",
  "દાઢ",
  "દાસ",
  "દાસત્વ",
  "દાસના દાસ",
  "દિવ્ય સ્વરૂપ",
  "દિવ્યભાવ",
  "દીકરા",
  "દીક્ષા",
  "દેહભાવ",
  "દોડવું",
  "ધામ",
  "ધામમાં લઈ ગયા",
  "ધામમાં લઈ જવા",
  "ધીરજ",
  "ધ્યાન",
  "નમવું",
  "નર્ક",
  "નવું વર્ષ",
  "નાની દીકરી",
  "નામ",
  "નારિયેળ",
  "નિમિત",
  "નિમિત્ત",
  "નિયમિતતા",
  "નિરાકાર",
  "નિર્દોષબુદ્ધિ",
  "નિર્માનીપણું",
  "નિર્વિકલ્પ",
  "નિર્વિકલ્પ ભજન",
  "નિવૃતિ",
  "નિષ્ઠા",
  "નેગટીવ વિચારો",
  "નેગેટિવિટી",
  "નોંધવું નહીં",
  "ન્યૂ ઈયર",
  "પતંગ",
  "પત્ર",
  "પરબ્રહ્મ",
  "પરભક્તિ",
  "પરલોક",
  "પરાભક્તિ",
  "પૂજા",
  "પોતાની સેવા જાતે કરવી",
  "પોતાનો દોષ જોવો",
  "પ્રગટ",
  "પ્રદર્શન",
  "પ્રભુનું બળ",
  "પ્રભુભક્તિ",
  "પ્રશ્ન",
  "પ્રશ્ન ઉત્તર",
  "પ્રશ્ન-ઉત્તર",
  "પ્રશ્નો",
  "પ્રશ્નોનું સમાધાન",
  "પ્રસંગ",
  "પ્રાર્થના",
  "પ્રીતિ",
  "પ્રેમ",
  "પ્રોપર્ટી",
  "પ્લેન",
  "ફોન",
  "બચાવ",
  "બળ",
  "બહેન",
  "બાથ",
  "બાળ પ્રવૃત્તિ",
  "બાળક",
  "બાળકો",
  "બાળપણ",
  "બિઝનેસ",
  "બીમાર",
  "બીમારી",
  "બુદ્ધિ",
  "બ્રહ્મ",
  "બ્રહ્મભાવ",
  "બ્રહ્મવિદ્યા",
  "બ્રેસલેટ",
  "બ્લડ",
  "બ્લડ રિપોર્ટ",
  "ભક્ત વત્સલ",
  "ભક્તિ",
  "ભગવદી",
  "ભજન",
  "ભાર",
  "ભારે",
  "ભીડો",
  "ભૂલ",
  "મંદિર",
  "મધ્ય ૧૩",
  "મન",
  "મનુષ્યભાવ",
  "મર્યાદા",
  "મશ્કરી",
  "મસ્તક",
  "મહારાજ",
  "મહિમા",
  "મહોત્સવ",
  "મા",
  "માતૃત્વ",
  "માન",
  "માન અપમાન માં અક્ષર",
  "માન અપમાનમાં અક્ષર",
  "માફી",
  "મિત્ર",
  "મુઝવણ",
  "મુમુક્ષુ",
  "મૂંઝવણ",
  "મોટપ",
  "મોઢે કરવું",
  "મોહ",
  "યુગકાર્ય",
  "યુવક",
  "યુવક સભા",
  "યુવતી",
  "યુવા પ્રવૃતિ",
  "યુવા પ્રવૃત્તિ",
  "યુવા સેવા",
  "રાજીપો",
  "રાત્રે",
  "રાત્રે પધરામણી",
  "રિયલ સાધુ",
  "રેલી",
  "રોગ",
  "લાલજી",
  "લીલા ચરિત્ર",
  "લેબોરેટરી",
  "વડીલ",
  "વરદાન",
  "વરસાદ",
  "વાંચન",
  "વાંઝણી",
  "વાતો",
  "વાસણા ફાર્મ",
  "વિડિયો ટીમ",
  "વિશાળતા",
  "વિશિષ્ટાદ્વૈત",
  "વિશ્વાસ",
  "વૃદ્ધ",
  "વેશ્યા",
  "વ્યર્થ સમય પસાર ના કરવો",
  "વ્યવહાર",
  "શરબત",
  "શાંતિ",
  "શિબિર",
  "શોભાયાત્રા",
  "શ્રવણ ભક્તિ",
  "સંકલ્પ",
  "સંત દ્વારા પ્રગટ",
  "સંતસમાગમ",
  "સંતો",
  "સંબંધ",
  "સંભારવા",
  "સંસ્કાર",
  "સંસ્કૃતિ",
  "સત્સંગ",
  "સદભાવ",
  "સભા",
  "સમાધાન",
  "સમૈયો",
  "સરળ",
  "સરળતા",
  "સર્વજ્ઞ",
  "સહજતા",
  "સહન કરવું",
  "સાક્ષી ભેદવો",
  "સાક્ષીભાવ",
  "સાધક",
  "સાધક માટે",
  "સાધુ",
  "સાધુતા",
  "સાનુકૂળતા",
  "સાફ સફાઈ",
  "સાફસૂફી",
  "સારથી",
  "સારા મિત્રો",
  "સિંહાસન",
  "સિક્સર",
  "સિદ્ધાંત",
  "સિન્સીયારીટી",
  "સુખ",
  "સુહૃદભાવ",
  "સૂત્ર",
  "સેવકભાવ",
  "સેવા",
  "સ્ટડી",
  "સ્ટેટસ",
  "સ્ટ્રેસ",
  "સ્મૃતિ",
  "સ્વધર્મ",
  "સ્વપ્ન",
  "સ્વભાવ",
  "સ્વરૂપ નિષ્ઠા",
  "સ્વરૂપનિષ્ઠા",
  "સ્વર્ગ",
  "સ્વસારપ",
  "સ્વાગત",
  "સ્વાધ્યાય",
  "સ્વામિનારાયણ",
  "સ્વામિની વાત",
  "સ્વામી સેવકભાવ",
  "સ્વામીની વાતો",
  "સ્વામીશ્રી",
  "સ્વામીશ્રી પરાવાણી",
  "સ્વામીશ્રીની સ્મૃતિમાં રમમાણ",
  "સ્વામીસેવકભાવ",
  "સ્વીકાર",
  "સ્વીમીંગ પુલ",
  "હાર",
  "હાર્ટ-શેપ",
  "હિંચકો",
  "હીંચકો",
  "હીરો",
  "હું",
  "હૃદય",
  "હોસ્પિટલ",
  "૨૦૨૦",
  "૨૦૨૧",
  "૨૦૨૨",
  "૨૦૨૩",
  "૨૦૨૪",
  "૨૦૨૫",
  "2022",
  "2023",
  "2024",
  "2025",
];

const gujaratiCollator = new Intl.Collator("gu-IN");
const SORTED_TAGS = [...TAGS].sort(gujaratiCollator.compare);

const PRASANG_INDEX_URL = "/data/prasang-index.json";
const LAST_READ_KEY = "prabodham-prasangam-last-read";


function writeCookie(name, value, days = 365) {
  if (typeof document === "undefined") return;
  const expires = new Date(
    Date.now() + days * 24 * 60 * 60 * 1000,
  ).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax`;
}

function readCookie(name) {
  if (typeof document === "undefined") return "";
  const pair = document.cookie
    .split(";")
    .map((s) => s.trim())
    .find((part) => part.startsWith(`${name}=`));
  return pair ? decodeURIComponent(pair.slice(name.length + 1)) : "";
}

function saveLastReadPrasang(prasang) {
  const payload = JSON.stringify({
    PsgId: prasang.PsgId,
    PsgContentFile: prasang.PsgContentFile,
  });
  try {
    localStorage.setItem(LAST_READ_KEY, payload);
  } catch {
    // no-op
  }
  writeCookie(LAST_READ_KEY, payload);
}

function loadLastReadPrasang() {
  let raw = "";
  try {
    raw = localStorage.getItem(LAST_READ_KEY) || "";
  } catch {
    // no-op
  }
  if (!raw) raw = readCookie(LAST_READ_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    if (!parsed?.PsgId && !parsed?.PsgContentFile) return null;
    return parsed;
  } catch {
    return null;
  }
}

function highlightWords(html, word) {
  if (!word || word.trim().length < 2) return html;
  const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const re = new RegExp(`(${escaped})`, "gi");
  return html.replace(
    re,
    '<mark style="background:#ffe066;color:#222;border-radius:2px">$1</mark>',
  );
}

function getSnippet(content, word) {
  const idx = content.toLowerCase().indexOf(word.toLowerCase());
  if (idx === -1) return "";
  const start = Math.max(0, idx - 80);
  const end = Math.min(content.length, idx + word.length + 80);
  let snippet = content.slice(start, end).replace(/\s+/g, " ").trim();
  if (start > 0) snippet = "..." + snippet;
  if (end < content.length) snippet += "...";
  return snippet;
}

function getSnippetForCandidates(content, candidates) {
  const lower = content.toLowerCase();
  let best = null;

  candidates.forEach((candidate) => {
    if (!candidate) return;
    const idx = lower.indexOf(candidate.toLowerCase());
    if (idx === -1) return;
    if (!best || idx < best.idx) {
      best = { idx, candidate };
    }
  });

  if (!best) return { snippet: "", hit: "" };
  return {
    snippet: getSnippet(content, best.candidate),
    hit: best.candidate,
  };
}

const ROMAN_WORD_OVERRIDES = {
  gunatit: "ગુણાતીત",
  gunatitn: "ગુણાતીત",
};

const ROMAN_CONSONANTS = {
  ksh: "ક્ષ",
  chh: "છ",
  kh: "ખ",
  gh: "ઘ",
  ch: "ચ",
  jh: "ઝ",
  th: "થ",
  dh: "ધ",
  ph: "ફ",
  bh: "ભ",
  sh: "શ",
  gn: "જ્ઞ",
  tr: "ત્ર",
  ny: "ન્ય",
  ng: "ઙ",
  k: "ક",
  g: "ગ",
  c: "ક",
  j: "જ",
  t: "ત",
  d: "દ",
  n: "ન",
  p: "પ",
  b: "બ",
  m: "મ",
  y: "ય",
  r: "ર",
  l: "લ",
  v: "વ",
  w: "વ",
  s: "સ",
  h: "હ",
  f: "ફ",
  q: "ક",
  x: "ક્સ",
  z: "ઝ",
  "~": "ળ",
  "^": "ટ",
};

const ROMAN_VOWELS = {
  aa: { independent: "આ", matra: "ા" },
  ai: { independent: "ઐ", matra: "ૈ" },
  au: { independent: "ઔ", matra: "ૌ" },
  ii: { independent: "ઈ", matra: "ી" },
  ee: { independent: "ઈ", matra: "ી" },
  oo: { independent: "ઊ", matra: "ૂ" },
  uu: { independent: "ઊ", matra: "ૂ" },
  a: { independent: "અ", matra: "" },
  i: { independent: "ઇ", matra: "િ" },
  u: { independent: "ઉ", matra: "ુ" },
  e: { independent: "એ", matra: "ે" },
  o: { independent: "ઓ", matra: "ો" },
};

const GUJARATI_PHONETIC_EQUIVALENTS = [
  [/િ|ી/g, "િ"],
  [/ુ|ૂ/g, "ુ"],
  [/ે|ૈ/g, "ે"],
  [/ો|ૌ/g, "ો"],
  [/ઁ|ં|ઃ/g, "ં"],
  [/શ|ષ|સ/g, "સ"],
  [/ળ/g, "લ"],
];

const GUJARATI_INDEPENDENT_VOWELS = {
  અ: "a",
  આ: "aa",
  ઇ: "i",
  ઈ: "i",
  ઉ: "u",
  ઊ: "u",
  ઋ: "ri",
  એ: "e",
  ઐ: "ai",
  ઓ: "o",
  ઔ: "au",
};

const GUJARATI_MATRAS = {
  "ા": "aa",
  "િ": "i",
  "ી": "i",
  "ુ": "u",
  "ૂ": "u",
  "ૃ": "ri",
  "ે": "e",
  "ૈ": "ai",
  "ો": "o",
  "ૌ": "au",
};

const GUJARATI_CONSONANTS = {
  ક: "k",
  ખ: "kh",
  ગ: "g",
  ઘ: "gh",
  ઙ: "ng",
  ચ: "ch",
  છ: "chh",
  જ: "j",
  ઝ: "jh",
  ઞ: "ny",
  ટ: "t",
  ઠ: "th",
  ડ: "d",
  ઢ: "dh",
  ણ: "n",
  ત: "t",
  થ: "th",
  દ: "d",
  ધ: "dh",
  ન: "n",
  પ: "p",
  ફ: "ph",
  બ: "b",
  ભ: "bh",
  મ: "m",
  ય: "y",
  ર: "r",
  લ: "l",
  વ: "v",
  શ: "sh",
  ષ: "sh",
  સ: "s",
  હ: "h",
  ળ: "l",
};

const GUJARATI_SIGNS = {
  "ં": "m",
  "ઃ": "h",
  "ઁ": "m",
};

const GUJARATI_VIRAMA = "્";

function isGujaratiText(text) {
  return /[\u0A80-\u0AFF]/.test(text || "");
}

function normalizeGujaratiPhonetic(text) {
  let normalized = (text || "").toLowerCase().replace(/\s+/g, "");
  GUJARATI_PHONETIC_EQUIVALENTS.forEach(([pattern, replacement]) => {
    normalized = normalized.replace(pattern, replacement);
  });
  return normalized;
}

function normalizeRomanPhonetic(text) {
  return (text || "")
    .toLowerCase()
    .replace(/[^a-z]/g, "")
    .replace(/aa/g, "a")
    .replace(/ee|ii/g, "i")
    .replace(/oo|uu/g, "u")
    .replace(/sh/g, "s")
    .replace(/ph/g, "f")
    .replace(/bh/g, "b")
    .replace(/dh/g, "d")
    .replace(/th/g, "t")
    .replace(/chh/g, "ch")
    .replace(/v/g, "w");
}

function gujaratiToRomanPhonetic(text) {
  const input = text || "";
  let out = "";

  for (let i = 0; i < input.length; i += 1) {
    const c = input[i];
    const next = input[i + 1] || "";

    if (c === "ક" && next === "્" && input[i + 2] === "ષ") {
      out += "ksh";
      i += 2;
      continue;
    }
    if (c === "જ" && next === "્" && input[i + 2] === "ઞ") {
      out += "gn";
      i += 2;
      continue;
    }

    if (GUJARATI_INDEPENDENT_VOWELS[c]) {
      out += GUJARATI_INDEPENDENT_VOWELS[c];
      continue;
    }

    if (GUJARATI_CONSONANTS[c]) {
      const base = GUJARATI_CONSONANTS[c];
      const nextChar = input[i + 1] || "";
      if (GUJARATI_MATRAS[nextChar]) {
        out += base + GUJARATI_MATRAS[nextChar];
        i += 1;
        continue;
      }
      if (nextChar === GUJARATI_VIRAMA) {
        out += base;
        i += 1;
        continue;
      }
      out += base + "a";
      continue;
    }

    if (GUJARATI_SIGNS[c]) {
      out += GUJARATI_SIGNS[c];
      continue;
    }

    out += " ";
  }

  out = out.replace(/a(\s|$)/g, "$1");
  return normalizeRomanPhonetic(out);
}

function transliterateRomanWordToGujarati(word) {
  const override = ROMAN_WORD_OVERRIDES[(word || "").toLowerCase()];
  if (override) return override;

  const input = (word || "")
    .replace(/L/g, "~")
    .replace(/T/g, "^")
    .toLowerCase()
    .replace(/[^a-z~^]/g, "");
  if (!input) return "";

  const vowels = Object.keys(ROMAN_VOWELS).sort((a, b) => b.length - a.length);
  const consonants = Object.keys(ROMAN_CONSONANTS).sort(
    (a, b) => b.length - a.length,
  );

  let out = "";
  let i = 0;
  while (i < input.length) {
    const remaining = input.slice(i);

    let vowelToken = "";
    for (const v of vowels) {
      if (remaining.startsWith(v)) {
        vowelToken = v;
        break;
      }
    }
    if (vowelToken) {
      out += ROMAN_VOWELS[vowelToken].independent;
      i += vowelToken.length;
      continue;
    }

    let consonantToken = "";
    for (const c of consonants) {
      if (remaining.startsWith(c)) {
        consonantToken = c;
        break;
      }
    }
    if (!consonantToken) {
      i += 1;
      continue;
    }

    out += ROMAN_CONSONANTS[consonantToken];
    i += consonantToken.length;

    const afterConsonant = input.slice(i);
    let followingVowel = "";
    for (const v of vowels) {
      if (afterConsonant.startsWith(v)) {
        followingVowel = v;
        break;
      }
    }
    if (followingVowel) {
      out += ROMAN_VOWELS[followingVowel].matra;
      i += followingVowel.length;
    }
  }

  return out;
}

function generateGujaratiLVariants(text) {
  const source = text || "";
  if (!/[લળ]/.test(source)) return [source];

  let variants = [""];
  for (const ch of source) {
    if (ch === "લ" || ch === "ળ") {
      const next = [];
      variants.forEach((prefix) => {
        next.push(prefix + "લ");
        next.push(prefix + "ળ");
      });
      variants = next;
      continue;
    }
    variants = variants.map((prefix) => prefix + ch);
  }
  return Array.from(new Set(variants));
}

function buildWordCandidates(query) {
  const q = (query || "").trim();
  if (!q) return [];

  const candidates = new Set([q]);
  const lowered = q.toLowerCase();

  if (!isGujaratiText(q) && /^[a-z\s]+$/i.test(q)) {
    const transliterated = q
      .split(/\s+/)
      .map((w) => transliterateRomanWordToGujarati(w))
      .filter(Boolean)
      .join(" ")
      .trim();
    if (transliterated) {
      generateGujaratiLVariants(transliterated).forEach((variant) => {
        candidates.add(variant);
        candidates.add(normalizeGujaratiPhonetic(variant));
      });
    }
    if (ROMAN_WORD_OVERRIDES[lowered]) {
      candidates.add(ROMAN_WORD_OVERRIDES[lowered]);
      candidates.add(normalizeGujaratiPhonetic(ROMAN_WORD_OVERRIDES[lowered]));
    }
  }

  if (isGujaratiText(q)) {
    candidates.add(normalizeGujaratiPhonetic(q));
  }

  return Array.from(candidates).filter(Boolean);
}

function PrabodhamPrasangam() {
  const [prasangs, setPrasangs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [serialSearch, setSerialSearch] = useState("");
  const [contentSearch, setContentSearch] = useState("");
  const [contentIndex, setContentIndex] = useState([]);
  const [contentSearchResults, setContentSearchResults] = useState(null);
  const [selectedCat, setSelectedCat] = useState(null);
  const [selected, setSelected] = useState(null);
  const [content, setContent] = useState("");
  const [contentLoading, setContentLoading] = useState(false);
  const [fontSize, setFontSize] = useState(1);
  const [selectedTag, setSelectedTag] = useState(null);
  const [darkMode, setDarkMode] = useDarkMode();
  const [resultHighlightWord, setResultHighlightWord] = useState("");
  const [lastReadPrasang, setLastReadPrasang] = useState(() =>
    loadLastReadPrasang(),
  );
  const activeRef = useRef(null);

  useEffect(() => {
    fetch(PRASANG_INDEX_URL)
      .then((r) => r.json())
      .then((data) => setContentIndex(data))
      .catch(() => {});
  }, []);

  const handleContentSearch = useCallback(() => {
    const word = contentSearch.trim();
    if (word.length < 2) return;

    const qLower = word.toLowerCase();
    const queryRomanNormalized = normalizeRomanPhonetic(word);
    const queryIsRoman = !isGujaratiText(word) && /^[a-z\s]+$/i.test(word);
    const candidates = buildWordCandidates(word);
    const normalizedCandidates = candidates.map((c) =>
      normalizeGujaratiPhonetic(c),
    );

    const matchFiles = new Set();
    let firstHitWord = "";

    contentIndex.forEach((entry) => {
      const contentText = entry.text || "";
      const contentLower = contentText.toLowerCase();
      const contentPhonetic = normalizeGujaratiPhonetic(contentText);
      if (!entry._romanPhonetic) {
        entry._romanPhonetic = gujaratiToRomanPhonetic(contentText);
      }

      let matched = false;
      for (let i = 0; i < candidates.length; i += 1) {
        const candidate = candidates[i];
        const normalized = normalizedCandidates[i];
        if (
          (candidate && contentLower.includes(candidate.toLowerCase())) ||
          (normalized && contentPhonetic.includes(normalized))
        ) {
          matched = true;
          if (!firstHitWord) firstHitWord = candidate;
          break;
        }
      }

      if (
        !matched &&
        queryIsRoman &&
        queryRomanNormalized &&
        entry._romanPhonetic.includes(queryRomanNormalized)
      ) {
        matched = true;
      }

      if (!matched && !contentLower.includes(qLower)) return;

      if (!firstHitWord) {
        const { hit } = getSnippetForCandidates(contentText, [
          ...candidates,
          word,
        ]);
        firstHitWord = hit || word;
      }

      matchFiles.add(entry.file);
    });

    setContentSearchResults(matchFiles);
    setResultHighlightWord(firstHitWord || word);
  }, [contentIndex, contentSearch]);

  const clearContentSearch = () => {
    setContentSearch("");
    setContentSearchResults(null);
    setResultHighlightWord("");
  };

  useEffect(() => {
    const fetchPrasangs = async () => {
      try {
        setLoading(true);
        const response = await fetch(API_URL);
        if (!response.ok) {
          throw new Error("Failed to fetch prasangs");
        }
        const data = await response.json();
        setPrasangs(data);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching prasangs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrasangs();
  }, []);

  const openPrasang = useCallback(
    async (prasang) => {
      setSelected(prasang);
      setLastReadPrasang({
        PsgId: prasang.PsgId,
        PsgContentFile: prasang.PsgContentFile,
      });
      saveLastReadPrasang(prasang);

      setContent("");
      setContentLoading(true);
      setFontSize(1);
      try {
        const res = await fetch(
          `${process.env.PUBLIC_URL}/data/prasang/${prasang.PsgContentFile}`,
        );
        if (!res.ok) throw new Error("File not found");
        let html = await res.text();
        html = html.replace(
          /<ul[^>]*class="reader_tools[^"]*"[^>]*>[\s\S]*?<\/ul>/i,
          "",
        );
        const highlightWord =
          contentSearchResults !== null
            ? (resultHighlightWord || contentSearch.trim())
            : "";
        html = highlightWords(html, highlightWord);
        setContent(
          html +
            `<style>
          .vaat_ind { font-family: inherit; line-height: 2; color: ${darkMode ? "#fff" : "#1a1a2e"}; padding: 4px 0; }
          .vaat_ind p { margin: 0 0 14px 0; font-size: 1.05em; line-height: 2; text-align: justify; color: ${darkMode ? "#fff" : "#1a1a2e"}; }
          .title_gu { font-size: 1.2em; font-weight: 700; color: #764ba2; margin-bottom: 16px; line-height: 1.6; text-align: center; }
        </style>`,
        );
      } catch {
        setContent('<p style="color:red">Could not load prasang content.</p>');
      } finally {
        setContentLoading(false);
      }
    },
    [contentSearch, contentSearchResults, darkMode, resultHighlightWord],
  );

  const contentTextMap = useMemo(
    () => new Map(contentIndex.map((e) => [e.file, e.text])),
    [contentIndex],
  );

  const filtered = useMemo(
    () =>
      prasangs.filter(
        (p) =>
          p.PsgId > 430 &&
          (selectedCat === null || p.CatId === selectedCat) &&
          (selectedTag === null ||
            p.EnglishTitle?.split(",")
              .map((t) => t.trim())
              .includes(selectedTag) ||
            p.HindiTitle?.split(",")
              .map((t) => t.trim())
              .includes(selectedTag) ||
            contentTextMap
              .get(p.PsgContentFile)
              ?.toLowerCase()
              .includes(selectedTag.toLowerCase())) &&
          (contentSearchResults === null ||
            contentSearchResults.has(p.PsgContentFile)) &&
          ((p.PsgTitle || "").toLowerCase().includes(search.toLowerCase()) ||
            (p.PsgContent || "").includes(search)) &&
          (!serialSearch.trim() ||
            String(p.PsgId).includes(serialSearch.trim())),
      ),
    [
      prasangs,
      selectedCat,
      selectedTag,
      contentTextMap,
      contentSearchResults,
      search,
      serialSearch,
    ],
  );

  const selectedIndex = useMemo(() => {
    if (!selected) return -1;
    return filtered.findIndex((p) => p.PsgId === selected.PsgId);
  }, [filtered, selected]);

  useEffect(() => {
    activeRef.current?.scrollIntoView({ block: "nearest" });
  }, [selected]);

  const goToRelativePrasang = useCallback(
    (delta) => {
      if (!selected || selectedIndex < 0) return;
      const targetIndex = selectedIndex + delta;
      if (targetIndex < 0 || targetIndex >= filtered.length) return;
      const target = filtered[targetIndex];
      if (target) openPrasang(target);
    },
    [filtered, openPrasang, selected, selectedIndex],
  );

  useEffect(() => {
    const onKeyDown = (event) => {
      const tag = (event.target?.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea") return;
      if (!selected) return;

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goToRelativePrasang(-1);
      }
      if (event.key === "ArrowRight") {
        event.preventDefault();
        goToRelativePrasang(1);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [goToRelativePrasang, selected]);

  const openLastRead = useCallback(() => {
    if (!lastReadPrasang) return;
    const prasang = prasangs.find(
      (p) =>
        (lastReadPrasang.PsgId && p.PsgId === lastReadPrasang.PsgId) ||
        (lastReadPrasang.PsgContentFile &&
          p.PsgContentFile === lastReadPrasang.PsgContentFile),
    );
    if (prasang) openPrasang(prasang);
  }, [lastReadPrasang, openPrasang, prasangs]);

  return (
    <main
      className={`page-content pravachan-page swamini-vato-page scripture-reader${darkMode ? " sv-dark" : ""}`}
    >
      <section className="page-header">
        <h1 className="section-title">
          Prabodham Prasangam
          {!loading && !error && (
            <span
              style={{ fontSize: "1rem", marginLeft: "12px", color: "#888" }}
            >
              ({filtered.length})
            </span>
          )}
        </h1>
        <p className="header-subtitle">
          Guruhari P.P. Prabodhjivan Swamiji Prasang
        </p>
        {lastReadPrasang && (
          <button
            type="button"
            className="last-read-vat"
            onClick={openLastRead}
            title="Open last read prasang"
          >
            Last Read: #{lastReadPrasang.PsgId}
          </button>
        )}
      </section>

      <section className="page-body">
        {!loading && !error && (
          <form
            className="word-search-bar"
            onSubmit={(e) => {
              e.preventDefault();
              handleContentSearch();
            }}
          >
            <input
              className="word-search-input"
              type="text"
              placeholder="પ્રસંગમાં શોધ... (Search in content)"
              value={contentSearch}
              onChange={(e) => setContentSearch(e.target.value)}
            />
            <button type="submit" className="word-search-btn">
              Search
            </button>
            <button
              type="button"
              className="word-search-clear"
              onClick={() => setDarkMode((d) => !d)}
              title="Toggle light/dark mode"
            >
              {darkMode ? "Light" : "Dark"}
            </button>
            {contentSearchResults !== null && (
              <button
                type="button"
                className="word-search-clear"
                onClick={clearContentSearch}
              >
                x Clear
              </button>
            )}
          </form>
        )}

        {!loading && !error && contentSearchResults !== null && (
          <div
            style={{
              fontSize: "0.82em",
              color: "#764ba2",
              marginBottom: 14,
              textAlign: "center",
            }}
          >
            {filtered.length} result{filtered.length !== 1 ? "s" : ""} for "
            {contentSearch}"
          </div>
        )}

        {/* Category filters */}
        {!loading && !error && prasangs.length > 0 && (
          <div
            className="prasang-filter-list"
            role="group"
            aria-label="Categories"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
              justifyContent: "center",
              marginBottom: 20,
            }}
          >
            <button
              onClick={() => setSelectedCat(null)}
              aria-pressed={selectedCat === null}
              style={{
                padding: "5px 14px",
                borderRadius: 20,
                fontWeight: 600,
                fontSize: "0.85em",
                cursor: "pointer",
              }}
            >
              All
            </button>
            {CATEGORIES.map((cat) => (
              <button
                key={cat.id}
                onClick={() =>
                  setSelectedCat(selectedCat === cat.id ? null : cat.id)
                }
                title={cat.en}
                aria-pressed={selectedCat === cat.id}
                style={{
                  padding: "5px 14px",
                  borderRadius: 20,
                  fontWeight: 600,
                  fontSize: "0.85em",
                  cursor: "pointer",
                }}
              >
                {cat.gu}
              </button>
            ))}
          </div>
        )}

        {/* Tag filters */}
        {!loading && !error && prasangs.length > 0 && (
          <div
            className="prasang-filter-list prasang-filter-list--tags"
            role="group"
            aria-label="Tags"
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignContent: "flex-start",
              gap: 6,
              justifyContent: "center",
              marginBottom: 20,
              padding: "10px 0",
              maxHeight: "320px",
              overflowY: "auto",
              overflowX: "hidden",
              paddingRight: 6,
            }}
          >
            <button
              onClick={() => setSelectedTag(null)}
              aria-pressed={selectedTag === null}
              style={{
                padding: "3px 12px",
                borderRadius: 14,
                fontWeight: 600,
                fontSize: "0.78em",
                cursor: "pointer",
              }}
            >
              All Tags
            </button>
            {SORTED_TAGS.map((tag) => (
              <button
                key={tag}
                onClick={() => setSelectedTag(selectedTag === tag ? null : tag)}
                aria-pressed={selectedTag === tag}
                style={{
                  padding: "3px 12px",
                  borderRadius: 14,
                  fontWeight: 500,
                  fontSize: "0.78em",
                  cursor: "pointer",
                }}
              >
                {tag}
              </button>
            ))}
          </div>
        )}

        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading prasangs...</p>
          </div>
        )}

        {error && (
          <div className="error-container">
            <p>Error loading prasangs: {error}</p>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        )}

        {!loading && !error && (
          <div className="vachanamrut-body">
            {/* Left list */}
            <aside className="vachanamrut-list-panel">
              <input
                className="vachanamrut-search"
                type="text"
                placeholder="Filter by title or serial no..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <input
                className="vachanamrut-search vachanamrut-search-serial"
                type="text"
                placeholder="Serial no search (e.g. 431 or 512)"
                value={serialSearch}
                onChange={(e) =>
                  setSerialSearch(e.target.value.replace(/[^\d]/g, ""))
                }
              />
              <ul
                className={`vachanamrut-list${
                  contentSearchResults !== null ? " search-results-scroll-list" : ""
                }`}
              >
                {filtered.map((prasang) => {
                  const isActive = selected?.PsgId === prasang.PsgId;
                  return (
                    <li
                      key={prasang.PsgId}
                      ref={isActive ? activeRef : null}
                      className={`vachanamrut-item${isActive ? " active" : ""}`}
                      aria-current={isActive ? "true" : undefined}
                      onClick={() => openPrasang(prasang)}
                    >
                      <span className="vachan-name">#{prasang.PsgId}</span>
                      <span className="vachan-name-guj">
                        {prasang.PsgTitle}
                      </span>
                      {prasang.PsgContent && (
                        <span
                          className="vachan-name-guj reader-muted"
                          style={{ fontSize: "0.82em", color: "#777" }}
                        >
                          {prasang.PsgContent}
                        </span>
                      )}
                    </li>
                  );
                })}
              </ul>
              {filtered.length === 0 && (
                <p className="reader-muted" style={{ textAlign: "center", color: "#888", padding: 24 }}>
                  No prasangs found.
                </p>
              )}
            </aside>

            {/* Right content */}
            <section className="vachanamrut-content-panel">
              {!selected ? (
                <div className="vachanamrut-placeholder">
                  <p>વાંચવા માટે ડાબી બાજુથી પ્રસંગ પસંદ કરો.</p>
                  <p>Select a prasang from the list to read.</p>
                </div>
              ) : (
                <>
                  <div className="font-resize-bar" style={{ marginBottom: 16 }}>
                    <button
                      onClick={() => goToRelativePrasang(-1)}
                      disabled={selectedIndex <= 0}
                      title="Previous (Left Arrow)"
                    >
                      ← Prev
                    </button>
                    <button
                      onClick={() => goToRelativePrasang(1)}
                      disabled={
                        selectedIndex === -1 ||
                        selectedIndex >= filtered.length - 1
                      }
                      title="Next (Right Arrow)"
                    >
                      Next →
                    </button>
                    <button
                      onClick={() =>
                        setFontSize((s) => Math.max(s - 0.15, 0.7))
                      }
                    >
                      A-
                    </button>
                    <button
                      onClick={() =>
                        setFontSize((s) => Math.min(s + 0.15, 2.5))
                      }
                    >
                      A+
                    </button>
                    <span>{Math.round(fontSize * 100)}%</span>
                  </div>
                  {contentLoading ? (
                    <div className="vachanamrut-loading">Loading...</div>
                  ) : (
                    <div
                      className="reader-html"
                      dangerouslySetInnerHTML={{ __html: content }}
                      style={{
                        color: darkMode ? "#fff" : "#1a1a2e",
                        fontFamily: "inherit",
                        lineHeight: 1.8,
                        wordBreak: "break-word",
                        zoom: fontSize,
                      }}
                    />
                  )}
                </>
              )}
            </section>
          </div>
        )}
      </section>
    </main>
  );
}

export default PrabodhamPrasangam;
